import React, { useEffect, useState } from 'react';
import { AudioPlayer } from './AudioPlayer';
// Cookie helper functions
const setCookie = (name: string, value: string, days: number = 7) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};
const getCookie = (name: string) => {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
};
export const Hero = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Debug log to check component rendering
    console.log('Hero component mounted');
    // Check if timer exists in cookies or set default
    const storedTimer = getCookie('specialOfferTimer');
    if (storedTimer) {
      try {
        setTimeLeft(JSON.parse(storedTimer));
      } catch (error) {
        // If JSON parsing fails, reset to default
        setTimeLeft({
          hours: 4,
          minutes: 59,
          seconds: 59
        });
      }
    }
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        let newHours = prevTime.hours;
        let newMinutes = prevTime.minutes;
        let newSeconds = prevTime.seconds - 1;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        if (newHours < 0) {
          // Reset to 4:59:59 when timer reaches zero
          newHours = 4;
          newMinutes = 59;
          newSeconds = 59;
        }
        const newTime = {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
        // Save to cookie with 7-day expiration
        setCookie('specialOfferTimer', JSON.stringify(newTime), 7);
        return newTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-gradient-to-b from-blue-900 to-blue-800 py-8 md:py-20 relative overflow-hidden hero-section" data-id="element-145">
      {/* Mobile-only timer - now fixed at top of screen */}
      <div className="md:hidden fixed top-0 left-0 w-full bg-red-600 text-white text-center py-1.5 px-2 shadow-md z-50" data-id="element-146">
        <p className="font-bold text-xs" data-id="element-147">
          LIMITED TIME OFFER: Ends in{' '}
          <span className="text-yellow-300" data-id="element-148">
            {String(timeLeft.hours).padStart(2, '0')}:
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </p>
      </div>
      {/* Add padding to top on mobile to prevent content from being hidden behind the fixed timer */}
      <div className="md:hidden h-8" data-id="element-149"></div>
      {/* American flag-inspired background elements */}
      {/* Stars element - hidden on mobile */}
      <div className="absolute top-4 left-4 md:top-8 md:left-8 hidden md:block" data-id="element-150"></div>
      <div className="container mx-auto px-3 max-w-6xl relative z-10" data-id="element-151">
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-12" data-id="element-152">
          <div className="md:w-1/2" data-id="element-153">
            {/* Bestseller ribbon above headline */}
            <div className="flex items-center mb-2 md:mb-4" data-id="element-154">
              <div className="bg-red-700 text-white px-3 py-0.5 rounded-full font-bold text-xs shadow-md" data-id="element-155">
                BESTSELLER
              </div>
              <div className="flex ml-2" data-id="element-156">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-157">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-158" />
                  </svg>)}
              </div>
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-2 md:mb-4" data-id="element-159">
              Charlie Kirk: Life, Quotes & Legacy
            </h1>
            <h2 className="text-lg md:text-2xl text-blue-300 md:text-red-300 font-medium mb-2 md:mb-6" data-id="element-160">
              The young philosopher who turned a microphone into a movement
            </h2>
            <p className="text-base md:text-xl font-semibold text-blue-200 md:text-gray-100 mb-3 md:mb-6" data-id="element-161">
              A patriotic voice for America's future
            </p>
            {/* Desktop-only button under the "A patriotic voice" text */}
            <div className="hidden md:block mb-8" data-id="element-162">
              <a href="#offer" className="inline-block w-full max-w-md bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300 border-2 border-white shadow-lg relative z-20 text-center" data-id="element-163">
                Get My Copy Now
              </a>
            </div>
            {/* Desktop-only Audio Player below button */}
            <div className="hidden md:block" data-id="element-164">
              <AudioPlayer audioUrl="https://share.deal.ai/files/68f90bc9dfdfc692abb20b2c/583aef26-da02-4d81-bef7-83bc25cded51" title="Listen to a Preview" data-id="element-165" />
            </div>
          </div>
          <div className="md:w-1/2 relative mt-2 md:mt-0" data-id="element-166">
            <div className="absolute inset-0 rounded-md bg-red-600 shadow-lg transform -rotate-12" data-id="element-167"></div>
            {/* Book Cover with Badge */}
            <div className="relative" data-id="element-168">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dYFotzjk1xaBZdxesCRrDD/Generated_Image_October_13%2C_2025_-_2_04PM.png" alt="Charlie Kirk Book Cover" className="w-full max-w-md mx-auto shadow-2xl rounded-md relative z-10" width="500" height="500" loading="eager" fetchpriority="high" data-id="element-169" />
              {/* "Now Available Online" Badge - Smaller size */}
              <div className="absolute -top-2 -right-2 md:-top-4 md:-right-4 w-14 h-14 md:w-20 md:h-20 z-20" data-id="element-170">
                <div className="relative w-full h-full" data-id="element-171">
                  <div className="absolute inset-0 rounded-full bg-blue-600 md:bg-red-600 shadow-lg transform -rotate-12 scale-90 sm:scale-100" data-id="element-172"></div>
                  <div className="absolute inset-1 rounded-full bg-blue-700 flex items-center justify-center" data-id="element-173">
                    <div className="text-center" data-id="element-174">
                      <p className="text-white text-[7px] md:text-[10px] font-bold" data-id="element-175">
                        NOW
                      </p>
                      <p className="text-white text-[7px] md:text-[10px] font-bold" data-id="element-176">
                        AVAILABLE
                      </p>
                      <p className="text-white text-[7px] md:text-[10px] font-bold" data-id="element-177">
                        ONLINE
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Mobile-only Audio Player */}
            <div className="mt-4 md:hidden" data-id="element-178">
              <AudioPlayer audioUrl="https://share.deal.ai/files/68f90bc9dfdfc692abb20b2c/583aef26-da02-4d81-bef7-83bc25cded51" title="Listen to a Preview" data-id="element-179" />
            </div>
            {/* Button moved below the audio player - visible only on mobile */}
            <div className="mt-4 flex justify-center md:hidden" data-id="element-180">
              <a href="#offer" className="inline-block w-full max-w-md mx-auto bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-lg text-base transition-colors duration-300 border-2 border-white shadow-lg relative z-20 text-center" data-id="element-181">
                YES! I Want This Book
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};